module.exports = __webpack_public_path__ + "static/hero-image-mobile-cd9ca708f3698a7ef6c56fe902054d31.svg";